"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAddressDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const swagger_1 = require("@nestjs/swagger");
/**
 * DTO for creating an address.
 * @class CreateAddressDto
 */
class CreateAddressDto {
}
exports.CreateAddressDto = CreateAddressDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Address Type ID",
        type: Number,
        required: true,
        example: 25,
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Address Type id is required." }),
    (0, class_validator_1.IsInt)({ message: "Address Type id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateAddressDto.prototype, "addressTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Address",
        type: String,
        required: true,
        example: "123 Main St",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Address is required." }),
    (0, class_validator_1.IsString)({ message: "Address must be a string." }),
    (0, class_validator_1.MaxLength)(255, { message: "Address must not exceed 255 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], CreateAddressDto.prototype, "address1", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Country ID",
        type: Number,
        required: true,
        example: 1,
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Country id is required." }),
    (0, class_validator_1.IsInt)({ message: "Country id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateAddressDto.prototype, "countryId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "State ID",
        type: Number,
        required: true,
        example: 1,
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "State id is required." }),
    (0, class_validator_1.IsInt)({ message: "State id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateAddressDto.prototype, "stateId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "City ID",
        type: Number,
        required: true,
        example: 1,
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "City id is required." }),
    (0, class_validator_1.IsInt)({ message: "City id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateAddressDto.prototype, "cityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Address 2",
        type: String,
        example: "Address v23",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Address 2 must be a string." }),
    (0, class_validator_1.MaxLength)(255, { message: "Address 2 must not exceed 255 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], CreateAddressDto.prototype, "address2", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Area",
        type: String,
        example: "Downtown",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Area must be a string." }),
    (0, class_validator_1.MaxLength)(100, { message: "Area must not exceed 100 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], CreateAddressDto.prototype, "area", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Postal Code",
        type: String,
        example: "12345",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Postal code is required." }),
    (0, class_validator_1.IsString)({ message: "Postal code must be a string." }),
    (0, class_validator_1.Matches)(/^[A-Za-z0-9\s\-]{3,10}$/, {
        message: "Postal code must be 3-10 characters long and can only contain letters, numbers, spaces, and hyphens.",
    }),
    tslib_1.__metadata("design:type", String)
], CreateAddressDto.prototype, "pinCode", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Phone Number",
        type: String,
        required: true,
        example: "1234567890",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Phone number is required." }),
    (0, class_validator_1.IsString)({ message: "Phone number must be a string." }),
    (0, class_validator_1.Matches)(/^[0-9]{10}$/, {
        message: "Phone number must be a valid 10-digit number.",
    }),
    tslib_1.__metadata("design:type", String)
], CreateAddressDto.prototype, "phoneNumber", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Alternate Phone Number",
        type: String,
        example: "0987654321",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Alternate Phone number must be a string." }),
    (0, class_validator_1.Matches)(/^[0-9]{10}$/, {
        message: "Alternate Phone number must be a valid 10-digit number.",
    }),
    tslib_1.__metadata("design:type", String)
], CreateAddressDto.prototype, "alternatePhoneNumber", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Email",
        type: String,
        example: "email@1811.com",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Email must be a string." }),
    (0, class_validator_1.Matches)(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, {
        message: "Invalid email format.",
    }),
    tslib_1.__metadata("design:type", String)
], CreateAddressDto.prototype, "email", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Support Number",
        type: String,
        example: "1234567890",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Support number must be a string." }),
    tslib_1.__metadata("design:type", String)
], CreateAddressDto.prototype, "supportNumber", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateAddressDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateAddressDto.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], CreateAddressDto.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], CreateAddressDto.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiHideProperty)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateAddressDto.prototype, "id", void 0);
